import React from "react"
import styles from "./MainTitles.module.css"

const HomepageTitles = props => {
  return (
    <div className="row pt-5 mt-5 mt-lg-5">
      <p
        role="heading"
        aria-level="1"
        className={`${styles.main_title} col-12 text-center text-dark`}
      >
        Full Stack Developer & Entrepreneur
      </p>

      <p
        role="heading"
        aria-level="2"
        className={`${styles.main_subtitle} col-10 col-sm-9 mx-auto text-secondary text-center`}
      >
        Hi, I am Nishant. I help businesses grow by solving their engineering
        problems.
      </p>
    </div>
  )
}

export default HomepageTitles
